import axios from 'axios'
import { apiUrl } from './environment'

export const updateUserAvatar = async (form: FormData) => {
  try {
    const response = await axios.put(
      `${apiUrl}image`,
      form,
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    console.error(error)
  }
}
